module.exports = __webpack_public_path__ + "static/web-75c21e96eca98e1d9d40627fe8e5e48d.png";